import { useContext } from "react";
import { VarifyContext } from "./VarifyContext";

export const useGetVarifyExperiments = () => {
    const experimentsStore = useContext(VarifyContext); 
    return experimentsStore;
}